export default __webpack_public_path__ + "static/media/ruby.df862c78.svg";